<template>
  <div>
    <Header />
    <slot />
    <!-- <Footer /> -->
  </div>
</template>
<style lang="scss" scoped>
</style>
<script>
import Header from '@/components/Header/Header.vue';
// import Footer from '@/components/Footer/Footer.vue';

export default {
  name: 'default-layout',
  components: {
    Header,
    // Footer,
  },

};
</script>
<style lang="scss" scoped>
</style>
